import { createFileRoute } from '@tanstack/react-router'

import { UnsExplorer } from '@/components/UnsExplorer'

export const Route = createFileRoute('/_app/automotive/explorer')({
  component: AutomotiveExplorerPage,
})

function AutomotiveExplorerPage() {
  return (
    <UnsExplorer
      wsAddress={import.meta.env.VITE_SHARED_WS_ADDRESS}
      username={import.meta.env.VITE_WS_USERNAME}
      password={import.meta.env.VITE_WS_PASSWORD}
      rootName="ConnCorp"
      topicFilters="ConnCorp/#"
      clientIdPrefix="stories_uns_automotive"
    />
  )
}
